module.exports = __webpack_public_path__ + "img/cave-art.5bbb148b.jpg";